import React, {useContext, useState} from "react"
import PropTypes from "prop-types";
import Loading from "components/Loading";
import FormTranslationContext from "context/FormTranslationContext";
import {Table, TableHead, TableRow} from "@material-ui/core";
import AnnualReportTableCell from "../common/AnnualReportTableCell";
import annualReportSteps from "../../constants/annualReportSteps";
import Tr from "translations/Translations";
import AnnualReportEditPopup from "../common/AnnualReportEditPopup";
import AnnualReportBelowEuEditForm from "./AnnualReportBelowEuEditForm";
import AnnualReportBelowEuTablePart from "./AnnualReportBelowEuTablePart";
import MoveAnnualReportEntry from "../common/MoveAnnualReportEntry";
import AnnualReportSearchBar from "../common/AnnualReportSearchBar";
import AnnualReportTableHeadCell from "../common/AnnualReportTableHeadCell";

const reportStep = annualReportSteps.belowEu;

function AnnualReportBelowEuForm(
    {
        initValues,
        classes,
        disabled
    }
) {
    const {getDict, dictTranslations} = useContext(FormTranslationContext);
    const [types] = useState(getDict("MP.MMiA.BelowEU.procedure"));
    const [editPopup, setEditPopup] = useState(null);
    const [movePopup, setMovePopup] = useState(null);
    const [search, setSearch] = useState({search: ""});

    if (!initValues) return <Loading/>
    return (<>
        <AnnualReportSearchBar reportStep={reportStep} setSearch={setSearch} classes={classes} disabled={disabled} setEditPopup={setEditPopup}/>

        <Table>
            <TableHead>
                <TableRow className={classes.tableMainHeaderRow}>
                    <AnnualReportTableCell borderLeft borderRight colSpan={2}>
                        {dictTranslations.orderType["Services"]}
                    </AnnualReportTableCell>
                    <AnnualReportTableCell borderRight colSpan={2}>
                        {dictTranslations.orderType["Delivery"]}
                    </AnnualReportTableCell>
                    <AnnualReportTableCell borderRight colSpan={3}>
                        {dictTranslations.orderType["Works"]}
                    </AnnualReportTableCell>
                    <AnnualReportTableCell borderRight></AnnualReportTableCell>
                </TableRow>
                <TableRow className={classes.tableMainHeaderRow}>
                    <AnnualReportTableHeadCell label="mmia.belowEu.count"/>
                    <AnnualReportTableHeadCell borderLeft={false} borderRight label="mmia.belowEu.amount"/>
                    <AnnualReportTableHeadCell label="mmia.belowEu.count"/>
                    <AnnualReportTableHeadCell borderLeft={false} borderRight label="mmia.belowEu.amount"/>
                    <AnnualReportTableHeadCell label="mmia.belowEu.count"/>
                    <AnnualReportTableHeadCell borderLeft={false} borderRight label="mmia.belowEu.amount" colSpan={2}/>
                    <AnnualReportTableCell borderRight>
                    </AnnualReportTableCell>
                </TableRow>

                {
                    types.map((type) =>
                        <AnnualReportBelowEuTablePart
                            key={type.value}
                            classes={classes}
                            type={type.value}
                            disabled={disabled}
                            entries={initValues[type.value]}
                            search={search}
                            setEditPopup={setEditPopup}
                            setMovePopup={setMovePopup}
                        />
                    )
                }
            </TableHead>
        </Table>

        {
            !!editPopup &&
            <AnnualReportEditPopup
                onClose={() => setEditPopup(null)}
                config={editPopup}
                reportStep={annualReportSteps.belowEu}
                FormComponent={AnnualReportBelowEuEditForm}
            />
        }
        {
            !!movePopup &&
            <MoveAnnualReportEntry
                items={types.filter((item) => item.value !== movePopup.currentType)}
                onClose={() => setMovePopup(null)}
                inputLabel={Tr("demand_realization_type")}
                reportStep={reportStep}
                config={movePopup}
            />
        }
    </>)


}

AnnualReportBelowEuForm.prototype = {
    initValues: PropTypes.object.isRequired,
    disabled: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
}

export default AnnualReportBelowEuForm;